// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__c0vCs","inner":"Form_inner__27DhL","range":"Form_range__16i0y","name":"Form_name__kSsyG","actions":"Form_actions__17I9J"};